import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/HomePage.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../pages/AboutPage.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../pages/ContactPage.vue')
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: () => import('../pages/KnowledgePage.vue')
  },
  {
    path: '/business-services',
    name: 'BusinessServices',
    component: () => import('../pages/BusinessServicesPage.vue')
  },
  {
    path: '/legal-services',
    name: 'LegalServices',
    component: () => import('../pages/LegalServicesPage.vue')
  },
  {
    path: '/hk-registration',
    name: 'HongKongRegistration',
    component: () => import('../pages/HongKongRegistrationPage.vue')
  },
  {
    path: '/offshore-registration',
    name: 'OffshoreRegistration',
    component: () => import('../pages/OffshoreRegistrationPage.vue')
  },
  {
    path: '/odi-investment',
    name: 'ODIInvestment',
    component: () => import('../pages/ODIInvestmentPage.vue')
  },
  {
    path: '/vie-structure',
    name: 'VIEStructure',
    component: () => import('../pages/VIEStructurePage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0, behavior: 'smooth' }
  }
})

export default router
